/** README:
 *  和时间相关的公共方法，统一在该脚本中管理
 *
 *
 */
import dayjs from 'dayjs';



/** ====== [获取方法：时间信息] ========================================================================================================== */

export const OneDayMinutes = 1440;
export const OneDaySeconds = 86400;

/**
 * 获取一天的分钟总数
 * @returns
 */
export function getMinutesCountOf1Day() {
  return OneDayMinutes;
}


/**
 * 获取一天的秒总数
 * @returns
 */
export function getSecondsCountOf1Day() {
  return OneDaySeconds;
}

/**
 * 获取给定日期中的分钟列表
 * @param {*} date
 * @returns 数组 --- YYYY-MM-DD HH:mm:ss
 */
export function getMinutesOfDay(date) {
  // 确保传入的参数是一个有效的日期
  const startOfDay = dayjs(date).startOf('day'); // 获取该天的开始时间
  const minutesArray = [];

  // 循环生成每分钟的时间
  for (let i = 0; i < 1440; i++) { // 1440分钟 = 24小时
    const currentTime = startOfDay.add(i, 'minute'); // 当前时间
    minutesArray.push(currentTime.format('YYYY-MM-DD HH:mm:ss')); // 格式化并添加到数组
  }

  return minutesArray;
}


/**
 * 获取：【指定年份】中的【指定月份】
 * @param {*} year
 * @param {*} monthNum
 * @returns
 */
export function getTargetMonthOfYear(year = dayjs().format('YYYY'), monthNum = 1) {
  return dayjs(`${year}-${+monthNum}`).format('YYYY-MM');
}

/**
 * 获取：【指定年份】中的【开始月份】
 * @param {*} year
 * @returns
 */
export function getStartMonthOfYear(year = dayjs().format('YYYY')) {
  return dayjs(`${year}`).startOf('year').format('YYYY-MM')
}

/**
 * 获取：【指定年份】中的【结束月份】
 * @param {*} year
 * @returns
 */
export function getEndMonthOfYear(year = dayjs().format('YYYY')) {
  return dayjs(`${year}`).endOf('year').format('YYYY-MM')
}


/**
 * 获取：【指定年份】中的【开始日期】
 * @param {*} year
 * @returns
 */
export function getStartDateOfYear(year = dayjs().format('YYYY')) {
  return dayjs(`${year}`).startOf('year').format('YYYY-MM-DD')
}

/**
 * 获取：【指定年份】中的【结束日期】
 * @param {*} year
 * @returns
 */
export function getEndDateOfYear(year = dayjs().format('YYYY')) {
  return dayjs(`${year}`).endOf('year').format('YYYY-MM-DD')
}


/**
 * 获取：【指定月份】中的【开始日期】
 * @param {*} month
 * @returns
 */
export function getStartDateOfMonth(month = dayjs().format('YYYY-MM')) {
  if (typeof (month) === 'number' && month > 0 && month < 12) {
    const currYear = dayjs().format('YYYY');
    return dayjs(`${currYear}-${+month}`).startOf('month').format('YYYY-MM-DD');
  } else {
    return dayjs(month).startOf('month').format('YYYY-MM-DD');
  }
}

/**
 * 获取：【指定月份】中的【结束日期】
 * @param {*} month
 * @returns
 */
export function getEndDateOfMonth(month = dayjs().format('YYYY-MM')) {
  if (typeof (month) === 'number' && month > 0 && month < 12) {
    const currYear = dayjs().format('YYYY');
    return dayjs(`${currYear}-${+month}`).endOf('month').format('YYYY-MM-DD');
  } else {
    return dayjs(month).endOf('month').format('YYYY-MM-DD');
  }
}


/**
 * 获取给定月份中的日期列表
 * @param {*} month
 * @returns 数组 --- YYYY-MM-DD
 */
export function getDaysInMonth(month) {
  // 解析输入的月份，假设格式为 'YYYY-MM'
  const startOfMonth = dayjs(month).startOf('month'); // 获取该月的第一天
  const endOfMonth = startOfMonth.endOf('month'); // 获取该月的最后一天

  const daysArray = [];
  let currentDay = startOfMonth;

  // 遍历每一天，直到月底
  while (currentDay.isBefore(endOfMonth) || currentDay.isSame(endOfMonth)) {
    daysArray.push(currentDay.format('YYYY-MM-DD')); // 将日期格式化并添加到数组
    currentDay = currentDay.add(1, 'day'); // 移动到下一天
  }

  return daysArray; // 返回日期数组
}





/** ====== [检查校验：] ========================================================================================================== */
/**
 * 判断：日期格式是否有效
 * @param {*} date
 * @returns
 */
export function isValidDate(date) {
  return dayjs(date).isValid();
}



/**
 * 判断：日期是否是今天
 * @param {*} date
 * @returns
 */
export function isToday(date) {
  return dayjs(date).isSame(dayjs(), 'day'); // 比较日期是否在同一天
}

/**
 * 判断：日期是否是周末
 * @param {*} date
 * @returns
 */
export function isWeekEnd(date) {
  const weekIdx = dayjs(date).day();
  return (weekIdx === 6 || weekIdx === 0);
}


/**
 * 判断：两个日期是否属于同一个月
 * @param {*} d1
 * @param {*} d2
 * @returns
 */
export function isSameMonth(date1, date2) {
  return dayjs(date1).isSame(dayjs(date2), 'month');
}


/**
 * 判断：日期是否为一天的开始时刻
 * @param {*} date
 * @returns
 */
export function isStartOfDay(date) {
  return dayjs(date).isSame(dayjs(date).startOf('day'), 'second'); // 比较是否与当天的开始时间相同
};


/**
 * 判断：【日期】是否在给定的【日期范围】之内
 * @param {*} date
 * @param {*} dateRange
 * @returns
 */
export function checkDateIsInDateRange(date, dateRange) {
  const d = dayjs(date).startOf('day');
  const sd = dayjs(dateRange[0]).startOf('day');
  const ed = dayjs(dateRange[1]).endOf('day');
  return !(d.isBefore(sd) || d.isAfter(ed));
}







/** ====== [转换方法：时间转换] ========================================================================================================== */

/**
 * 从时间字符串中，获取分钟总数
 * @param {*} time '15:40'
 * @returns 940
 */
export function getMinutesCountByTime(time) {
  const arr = time.split(':');
  const h = +arr[0] * 60;
  const m = +arr[1] * 1;
  return h + m;
}


/**
 * 基于分钟数，计算对应于当天的时钟
 * @param {*} minutesCount 940
 * @returns '15:40'
 */
export function getTimeByMinutesCount(minutesCount) {
  let h = Math.floor(minutesCount / 60);
  let m = minutesCount % 60;
  h = h < 10 ? '0' + h : h;
  m = m < 10 ? '0' + m : m;
  return h + ':' + m;
}


/**
 * 从时间字符串中，获取秒总数
 * @param {*} time HH:mm:ss >>> num秒
 * @returns
 */
export function getSecondsCountByTime(time) {
  const arr = time.split(':');
  return Number(arr[0]) * 3600 + Number(arr[1]) * 60 + Number(arr[2]);
}


/**
 * 基于秒数，计算对应于当天的时钟
 * @param {*} secondsCount num秒 >>> HH:mm:ss
 * @returns
 */
export function getTimeBySecondsCount(secondsCount) {
  const h = Math.floor(secondsCount / 3600);
  const m = Math.floor((secondsCount - h * 3600) / 60);
  const s = secondsCount - h * 3600 - m * 60;
  return `${h < 10 ? '0' + h : h}:${m < 10 ? '0' + m : m}:${s < 10 ? '0' + s : s}`;
}



/** 转换：将【时间字符串】转换为【时间】 */
export function transformStrToTime(timeStr, refDate = '1970-01-01') {
  if (!isValidDate(refDate)) {
    refDate = undefined;
  }
  if (timeStr === '24:00') {
    return dayjs(refDate).startOf('day').add(1, 'day');
  } else {
    if (timeStr) {
      const [hh, mm] = timeStr.split(':');
      return dayjs(refDate).set('hour', hh).set('minute', mm).set('second', 0).set('millisecond', 0);
    } else {
      return undefined;
    }
  }
}



///////////////////////////////////////////【时区获取】///////////////////////////////////////////

export function getTimezoneOffset() {
  const offset = new Date().getTimezoneOffset() / 60;
  const symbol = offset <= 0 ? '+' : '-';
  return 'UTC' + symbol + Math.abs(offset);
}

/**
 * 处理接口返回数据中的时间字段
 * @param {object|array} [object] 对象或数组
 * @param {string[]} [timeKeys] 时间字段
 */
export function timeHandler(data, timeKeys = ['record_time']) {
  if (data == null) {
    throw new TypeError("处理数据不能为空！")
  }
  const traverseData = (data) => {
    if (Array.isArray(data)) {
      data.map(item => traverseData(item));
    } else if (typeof data === 'object' && data !== null) {
      Object.keys(data).forEach(key => {
        if (timeKeys.includes(key)) {
          const time = data[key];
          const offsetStr = getTimezoneOffset()
          const matcher = offsetStr.match(/([+-])(\d+)/)
          if (matcher) {
            const symbol = matcher[1];
            const offset = parseInt(matcher[2]);
            data[`__${key}`] = time;
            if (symbol === '+') {
              data[key] = dayjs(time).add(offset, 'hour').format("YYYY-MM-DD HH:mm:ss");
            } else if (symbol === '-') {
              data[key] = dayjs(time).subtract(offset, 'hour').format("YYYY-MM-DD HH:mm:ss");
            }
          }

        } else {
          traverseData(data[key]);
        }
      });
    }
  }

  traverseData(data);
}






